import type { Stripe } from "@stripe/stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import { captureException } from "@sentry/nextjs";

// The key is a build-time constant, so one cached promise is enough.
let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(stripeKey: string): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = loadStripe(stripeKey).catch((error: unknown) => {
      // Report here, not in each hook that shares this promise.
      captureException(error);
      // Do not keep a failed load, so that the next call loads again.
      stripePromise = null;
      throw error;
    });
  }

  return stripePromise;
}
